import { Avatar } from '@app/core/api/avatar';

/**
 * Avatar state interface for NgRx store
 * 
 * NOTE: activeAvatar is NOT stored here. It is derived from:
 * - preferences.active_avatar_id (single source of truth)
 * - avatars list (to get the full Avatar object)
 * See selectActiveAvatar in avatar.selectors.ts
 */
export interface AvatarState {
  // All avatars
  avatars: Avatar[];
  
  // Loading states
  loading: boolean;
  creatingAvatar: boolean;
  deletingAvatarId: string | null;
  deletingAllAvatars: boolean;
  
  // Loading state specifically for setting/removing active avatar
  settingActiveAvatar: boolean;
  
  // Error state
  error: string | null;
  
  // Cache timestamp for data freshness
  cacheTimestamp: number | null;
}

/**
 * Initial state for avatar feature
 */
export const initialAvatarState: AvatarState = {
  avatars: [],
  loading: false,
  creatingAvatar: false,
  deletingAvatarId: null,
  deletingAllAvatars: false,
  settingActiveAvatar: false,
  error: null,
  cacheTimestamp: null
};
